// extracted by mini-css-extract-plugin
export var chip = "_5l-0";
export var filterDropdown = "_5l-5";
export var filterItem = "_5l-6";
export var icon = "_5l-1";
export var removeButton = "_5l-3";
export var removeIcon = "_5l-4";
export var separator = "_5l-2";